'use strict';

var _ = require('lodash');
var SystemStatusCommonRendererFactory = function SystemStatusCommonRendererFactory($interpolate) {
  var statusIcons = {
    'FINISHED-PROCESSING': $interpolate(require('../templates/status-done.html')),
    'ERROR-PROCESSING': $interpolate(require('../templates/status-error.html')),
    'NEW_REQUEST': $interpolate(require('../templates/status-new-request.html')),
    'NEW-REQUEST': $interpolate(require('../templates/status-new-request.html')),
    'STARTED_PROCESSING': $interpolate(require('../templates/status-in-progress.html')),
    'STARTED-PROCESSING': $interpolate(require('../templates/status-in-progress.html')),
    'Created': $interpolate(require('../templates/status-new-request.html')),
    'created': $interpolate(require('../templates/status-new-request.html')),
    'running': $interpolate(require('../templates/status-in-progress.html')),
    'FINISHED-WITHOUT-SEND': $interpolate(require('../templates/status-warning.html')),
    //inconsistent status value for seasonality
    'Started processing...': $interpolate(require('../templates/status-in-progress.html')),
    'error': $interpolate(require('../templates/status-error.html')),
    'completed': $interpolate(require('../templates/status-done.html')),
    'PUBLISHED_CALENDAR': $interpolate(require('../templates/status-done.html')),
    'RETRYING-PROCESSING': $interpolate(require('../templates/status-in-progress.html')),
    'FINISHED-STEP': $interpolate(require('../templates/status-in-progress.html')),
    //Interface Status values
    'InProgress': $interpolate(require('../templates/status-in-progress.html')),
    'Completed': $interpolate(require('../templates/status-done.html')),
    'Error': $interpolate(require('../templates/status-error.html'))
  };
  var statusRenderer = function statusRenderer(columnContext, row, columnfield, value, defaultvalue) {
    if (statusIcons[value] === undefined) {
      return defaultvalue;
    } else {
      return defaultvalue.replace('>' + value + '<', '>' + statusIcons[value]({
        value: value
      }) + '<');
    }
  };
  var processedStatusRenderer = function processedStatusRenderer(columnContext, row, columnfield, value, defaultValue, column, rowData) {
    if (_.get(rowData, 'fileStatus', '') === 'InProgress') {
      return defaultValue.replace('>' + value + '<', '>' + statusIcons['STARTED-PROCESSING']({
        value: value
      }) + '<');
    }
    return defaultValue;
  };
  return {
    statusRenderer: statusRenderer,
    processedStatusRenderer: processedStatusRenderer
  };
};
SystemStatusCommonRendererFactory.$inject = ['$interpolate'];
module.exports = SystemStatusCommonRendererFactory;